import { useNavigate } from "react-router-dom";
import { backend } from "Backend";
import { useContext, useEffect } from "react";
import { useAppDispatch } from "redux/hooks";
import { USER_LOGOUT } from "redux/system.action";

import * as Sentry from "@sentry/react";
import { BroadcastChannelContext, SessionChangedMessage } from "contexts/BroadcastChannelContext";
import LoadingPattern from "components/LoadingPattern";
import { Box } from "@mui/material";

const Logout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const broadcastChannelMap = useContext(BroadcastChannelContext);

  const logout = async () => {
    await backend.logout();
    dispatch(USER_LOGOUT());
    broadcastChannelMap?.session?.postMessage(SessionChangedMessage.LOGGED_OUT);
    Sentry.setUser(null);
    navigate("/signin");
  };

  useEffect(() => {
    void logout();
  }, []);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 4,
      }}>
      <LoadingPattern />
    </Box>
  );
};

export default Logout;
